import React, { useEffect, useMemo, useState } from "react";
import "./PersonalDetails.css";
import { generateUniqueId } from "config/config";
import { toast } from "sonner";
import { createSubAdminAPI, editSubAdminApi } from "services/subAdmin";

const PersonalDetails = ({ detailsData, setSubAdminModal, getListHandler }) => {
  //************************ Handle ALL State ************************//

  const [permissionArray, setPermissionArray] = useState([
    {
      name: "Dashboard",
      title: "dashboard",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "user",
      name: "User Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "recipe",
      name: "Recipe Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "article",
      name: "Articles Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "content",
      name: "Content Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "subscription",
      name: "Subscription Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
    {
      title: "activity",
      name: "Activity Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
    {
      title: "report",
      name: "Report Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
  ]);

  const [formFields, setFormFields] = useState({
    email: "",
    number: "",
    address: "",
    fullName: "",
    password: "",
    cPassword: "",
    dialCode: "+91",
  });

  //*********************** Handle All Function **********************//

  // set Sub AdminDetails Handler
  const setSubAdminDetailsHandler = () => {
    if (detailsData?.callRole === "edit") {
      const { callRole, permissions, ...rest } = detailsData;

      const updatedPermissions = permissionArray.map((module) => {
        const title = module.title;

        const updatedPermissionsList = module.permission.map((perm) => {
          const permissionKey = `${title}.${perm.value}`;
          return {
            ...perm,
            isPermission: permissions.includes(permissionKey),
          };
        });

        return {
          ...module,
          permission: updatedPermissionsList,
        };
      });

      setFormFields({ ...rest });

      setPermissionArray(updatedPermissions);
    }
  };

  useEffect(() => {
    setSubAdminDetailsHandler();
  }, [detailsData?.callRole]);

  // onChangeHandler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "number") {
      const numericValue = value.replace(/\D/g, "");
      setFormFields({ ...formFields, number: numericValue });
    } else {
      setFormFields({ ...formFields, [name]: value });
    }
  };

  // setPermissionsHandler
  const setPermissionStateHandler = () => {
    let permissionArrayClone = [];

    for (let i = 0; i < permissionArray.length; i++) {
      for (let j = 0; j < permissionArray[i]?.permission.length; j++) {
        if (permissionArray[i]?.permission[j]?.isPermission) {
          permissionArrayClone = [
            ...permissionArrayClone,
            `${permissionArray[i]?.title}.${permissionArray[i]?.permission[j]?.value}`,
          ];
        }
      }
    }
    return permissionArrayClone;
  };

  // permission onChange Handler
  const permissionOnChangeHandler = (e, ind, i) => {
    const { checked } = e.target;
    let permissionArrayClone = permissionArray?.map((el) => el);
    let updatedItem = permissionArrayClone[ind];
    updatedItem = {
      ...updatedItem,
      permission: updatedItem?.permission?.map((el, perInd) => {
        if (perInd === i) {
          return {
            ...el,
            isPermission: checked,
          };
        } else {
          return {
            ...el,
          };
        }
      }),
    };
    permissionArrayClone[ind] = updatedItem;
    setPermissionArray(permissionArrayClone);
  };

  // Error Handler
  const errorHandler = () => {
    let isValid = true;
    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formFields?.fullName) {
      isValid = false;
      toast.error("Please Enter Full Name");
      return;
    }

    if (!formFields?.password && detailsData?.callRole !== "edit") {
      isValid = false;
      toast.error("Please Enter Password");
      return;
    }

    if (!formFields?.number) {
      isValid = false;
      toast.error("Please Enter Mobile Number");
      return;
    } else if (!mobileRegex.test(formFields.number)) {
      isValid = false;
      toast.error("Please Enter a Valid 10-Digit Mobile Number");
      return;
    }

    if (!formFields?.cPassword && detailsData?.callRole !== "edit") {
      isValid = false;
      toast.error("Please Enter Confirm Password");
      return;
    } else if (
      formFields?.password !== formFields?.cPassword &&
      detailsData?.callRole !== "edit"
    ) {
      isValid = false;
      toast.error("Confirm Password is invalid!");
      return;
    }
    if (!formFields?.email) {
      isValid = false;
      toast.error("Please Enter Email Address");
      return;
    } else if (!emailRegex.test(formFields.email)) {
      isValid = false;
      toast.error("Please Enter a Valid Email Address");
      return;
    }

    if (!formFields?.address) {
      isValid = false;
      toast.error("Please Enter Address");
      return;
    }
    return isValid;
  };

  // onSubmitHandler
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (errorHandler()) {
      try {
        const { cPassword, address, ...rest } = formFields;
        const permissionData = setPermissionStateHandler();

        let sendData = {
          ...rest,
          address,
          // street: address,
          resources: permissionData,
        };

        const { data } = await createSubAdminAPI(sendData);
        if (data?.success) {
          setSubAdminModal(false);
          toast.success(data?.message);
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  // updateSubAdminDetailsHandler
  const updateSubAdminDetailsHandler = async (e) => {
    e.preventDefault();
    if (errorHandler()) {
      try {
        const { password, cPassword, address, ...rest } = formFields;
        const permissionData = setPermissionStateHandler();

        let sendData = {
          ...rest,
          address,
          // street: address,
          resources: permissionData,
        };

        const { data } = await editSubAdminApi(sendData);
        if (data?.success) {
          setSubAdminModal(false);
          toast.success(data?.message);
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  //************************ Handle HTML CODE ************************//
  return (
    <div className="personal_details_parents">
      <div className="personal_form_wrap">
        <h4>Personal details</h4>
        {detailsData?.callRole === "edit" ? (
          <button className="button" onClick={updateSubAdminDetailsHandler}>
            Update
          </button>
        ) : (
          <button className="button" onClick={onSubmitHandler}>
            Create
          </button>
        )}
      </div>

      <form>
        <div className="form_field_wrap">
          <div className="form_field">
            <label htmlFor="fname" className="label">
              Sub-admin Name *
            </label>
            <input
              type="text"
              name="fullName"
              className="input"
              onChange={onChangeHandler}
              value={formFields?.fullName}
            />
          </div>

          {
            detailsData?.callRole !== "edit" &&
            <div className="form_field">
              <label htmlFor="password" className="label">
                Enter Password *
              </label>
              <input
                type="password"
                name="password"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.password}
                disabled={detailsData?.callRole === "edit"}
              />
            </div>
          }
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <label htmlFor="phn_number" className="label">
              Mobile Number *
            </label>
            <input
              type="text"
              name="number"
              maxLength={10}
              className="input"
              value={formFields?.number}
              onChange={onChangeHandler}
            />
          </div>

          {
            detailsData?.callRole !== "edit" &&
            <div className="form_field">
              <label htmlFor="password_con" className="label">
                Confirm Password *
              </label>
              <input
                type="password"
                name="cPassword"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.cPassword}
                disabled={detailsData?.callRole === "edit"}
              />
            </div>
          }
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <label htmlFor="email_address" className="label">
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              className="input"
              value={formFields?.email}
              onChange={onChangeHandler}
            />
          </div>

          <div className="form_field">
            {/* <label htmlFor="phn_number" className="label">
              Mobile Number
            </label>
            <input
              type="number"
              id="phn_number"
              name="phone_no"
              className="input"
            /> */}
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form_field">
            <label htmlFor="address" className="label">
              Address *
            </label>
            <textarea
              rows="6"
              cols="68"
              name="address"
              className="input textarea"
              onChange={onChangeHandler}
              value={formFields?.address}
            />
          </div>
        </div>
      </form>

      <div className="form_border_bottom"></div>

      <div className="access_heading">
        <h4>Access to</h4> <p>(Please Select atleast one role)</p>
      </div>

      <div className="check_box_wrap">
        {permissionArray?.length > 0 &&
          permissionArray?.map((item, ind) => (
            <div key={item?.uniqId} className="view_checkbox">
              <h6>{item?.name}</h6>
              {item?.permission?.map((el, i) => (
                <label key={i + 1}>
                  <input
                    type="checkbox"
                    value={el?.isPermission}
                    checked={el?.isPermission}
                    onChange={(e) => permissionOnChangeHandler(e, ind, i)}
                  />{" "}
                  <span>{el?.title}</span>
                </label>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default PersonalDetails;
